import React from "react";
import { graphql, useStaticQuery } from "gatsby";
import { FormProvider, useForm } from "react-hook-form";
import FormSelectField from "./form-select-field";
/* import { replaceLinks } from "../../utility/parser"; */
import { CDN_BASE_URL } from "../../utility/constants";
/* import Parser from "html-react-parser"; */

const ModelFind = ({ line, labelManagerLabels }) => {
  return (
    <>
      <div className="booklet__help">
        <p>{labelManagerLabels.bookletFindImage}</p>
        <div className="booklet__image-container">
          <img src={`${CDN_BASE_URL}/booklet/libretto-${line}.jpg`} alt={line} />
          <img src={`${CDN_BASE_URL}/booklet/libretto-label.jpg`} alt="booklet" />
        </div>
        {/*  <p> {Parser(labelManagerLabels.findProduct, { replace: replaceLinks })}</p> */}
      </div>
    </>
  );
};

const BookletLine = ({ currentLine, handleChangeLine, lineOptions, helpText }) => {
  const { labelManagerLabels } = useStaticQuery(graphql`
    {
      labelManagerLabels: labelManagerLabels {
        formProductLine
        findProduct
        bookletFindImage
      }
    }
  `);

  const methods = useForm();
  const { watch } = methods;
  const line = watch("line");
  return (
    <>
      <div className="booklet booklet-modal">
        <div className="booklet__form">
          <FormProvider {...methods}>
            <FormSelectField
              className="booklet__field"
              label={labelManagerLabels.formProductLine}
              value={currentLine ? currentLine : ""}
              name="line"
              onChange={handleChangeLine}
              options={lineOptions}
            />

            {line && (
              <>
                <ModelFind line={line} key={line} labelManagerLabels={labelManagerLabels} />
              </>
            )}
          </FormProvider>
        </div>
      </div>
    </>
  );
};

export default BookletLine;
